import { render, staticRenderFns } from "./PassengersHowItWorksLine01.vue?vue&type=template&id=04b21842&"
import script from "./PassengersHowItWorksLine01.vue?vue&type=script&lang=js&"
export * from "./PassengersHowItWorksLine01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports